module.exports = __webpack_public_path__ + "static/media/jack.16bd9779.jpg";